import { render, staticRenderFns } from "./ReportFilesAdmin.vue?vue&type=template&id=0db466dc&scoped=true"
import script from "./ReportFilesAdmin.vue?vue&type=script&lang=js"
export * from "./ReportFilesAdmin.vue?vue&type=script&lang=js"
import style0 from "./ReportFilesAdmin.vue?vue&type=style&index=0&id=0db466dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db466dc",
  null
  
)

export default component.exports